import {useLocation} from '@github-ui/react-router'

import type {ImmersivePlugin} from '../plugin/copilot-immersive-plugin'
import {usePlugins} from '../plugin/ImmersivePluginsProvider'
import {getActivePluginFromLocation} from '../plugin/plugin-helpers'

export function useActivePlugin(): ImmersivePlugin | undefined {
  const plugins = usePlugins()
  const location = useLocation()

  return getActivePluginFromLocation(location, plugins)
}
